import { get } from "svelte/store";
import { activePlayer } from "./ui";
import { ui } from "./stores";
import { resolveEffects, sanitize } from "./parse";
import { pegParse } from "./pegparse";

export async function executeArbitraryText(){
    let text = prompt('Enter text to execute');
    if(!text || !text.trim()) return;
    let c = get(ui).selection || activePlayer().decks.hand[0] || activePlayer().decks.deck[0];
    if(!c || !c.uniqueID){
        alert('Select a card first: arbitrary text is resolved as if it were on one.');
        return;
    }
    try{
        // pegParse (rather than the bare parser) so free text goes through the same ingestion as
        // card text: sanitise first, and let bindPrevObjs stamp the backreferences. It returns
        // {text, effects, response} and reports failures in `response`, so unwrap both.
        let parsed = pegParse(sanitize(text.trim()));
        if(!parsed || parsed.response == 'error' || !Array.isArray(parsed.response)){
            alert('Could not parse that text: ' + ((parsed && parsed.error) || 'unknown parse error'));
            return;
        }
        let effects = parsed.response.map(r => r.effect).filter(e => e);
        if(effects.length == 0){
            alert('Parsed, but there is nothing to execute in that text.');
            console.log(parsed.response);
            return;
        }
        await resolveEffects(c, effects, false);
    }catch(e){
        alert('Error '+(e.message || e.text || e));
        console.log(e);
    }
}
